import PrivateRoute from 'PrivateRoutes';
import React, { lazy } from 'react';
import { withRouter } from 'react-router';
// import Organization from './index';
const Organization = lazy(()=> import(/* webpackChunkName: "organization" */"./index"))

const routes = () => [
  <PrivateRoute
    key='organization-list'
    exact
    path='/organization'
    component={Organization}
  />,
];

export default withRouter(routes);



// WEBPACK FOOTER //
// src/modules/screens/organization/routes.js